@if (isLoading) {
  <div class="d-flex h-100">
    @if (radarChartData?.length > 0) {
      <div class="d-block col-9">
        <highcharts-chart
          class="w-100 d-block"
          [Highcharts]="highcharts"
          [callbackFunction]="chartCallback"
          [options]="chartOptions"
        ></highcharts-chart>
      </div>
    }
    <div class="legend-con col-3">
      <ul class="nav flex-column">
        <li class="nav-item font-weight-bold text-primary font-size-small mb-1">
          {{"WIND_DIRECTION_CHART.WIND_SPEED" |translate}} (m/s)
        </li>
        @for (legendItem of legendData; track legendItem.label; let i = $index) {
          <li class="nav-item mt-1 text-nowrap">
            <span class="chart-legend" [ngStyle]="{'background-color': legendItem.color}"></span>
            <span class="chart-legend-label-text">{{legendItem.label}}</span>
          </li>
        }
      </ul>
    </div>
  </div>
}

@if (!isLoading) {
  <div class="d-flex justify-content-center text-primary p-5 m-2">{{'COMMON.NO_DATA_AVAILABLE' | translate}}</div>
}
